import { Logger } from 'typescript-log'

const timeoutOccuredMsg = 'timeout occured'

// Permit the promise: Promise<any> to finish so error tracking does not pick up the reject at the network level
function promiseWithTimeout<T>(timeoutMs: number, promise: Promise<any>): Promise<T> {
    const timeout: Promise<T> = new Promise((_, reject) =>
        setTimeout(() => reject(new Error(timeoutOccuredMsg)), timeoutMs)
    )
    return Promise.race([timeout, promise])
}

const grapeShotCache: { [key: string]: string[] } = {}

// Returns a set of channels to be used in the gs_channels for an add call
export async function getGrapeshotChannels(logger: Logger, timeoutMs: number) {
    if (typeof window !== 'undefined') {
        const url =
            window.location !== window.top.location ? document.referrer : window.location.href

        // check cache first
        if (grapeShotCache[url]) {
            return grapeShotCache[url]
        }

        try {
            // timeout the grapeshot response

            logger.debug(
                { timeoutMs },
                'Preparing to make a Grapeshot request with a specified timeout'
            )

            // this is expected to run against a sevennews domain and not localhost so will throw cors errors locally
            const grapeshotResponse = await promiseWithTimeout<Response>(
                timeoutMs,
                fetch(
                    `//sevenwest.gscontxt.net/main/channels-json.cgi?url=${encodeURIComponent(url)}`
                )
            )

            const response: {
                channels: { name: string }[]
            } = await grapeshotResponse.json()

            const channels = response && response.channels ? response.channels.map(c => c.name) : []
            logger.debug(
                { channels },
                'Grapeshot request complete, channels returned, stored in cache'
            )
            // set cache
            // TODO: Check this eslint rule
            // eslint-disable-next-line require-atomic-updates
            grapeShotCache[url] = channels
            return channels
        } catch (err) {
            if ((err as Error).message !== timeoutOccuredMsg) {
                logger.error({ err }, 'Grapeshot call failed')
            }

            return 'timeout'
        }
    }
    return []
}
